import React, { useState } from "react";

import { Grid } from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";

import { Access } from "../../../../models/access";
import { DifferentLocation } from "../../../../models/location";
import BoxForm from "../../../Form/Box";
import Button, { Color } from "../../../Form/Button";
import AccessInfo from "./AccessInfo";
import useStyles from "./styles";

interface Props {
  pickupAccess?: Access;
  deliveryAccess?: Access;
  pickupAddress?: DifferentLocation;
  deliveryAddress?: DifferentLocation;
}

const DEFAULT_LATITUDE = -25.274398;
const DEFAULT_LONGITUDE = 133.77513599999997;

export default function AccessViewMode(props: Props) {
  const { pickupAccess, deliveryAccess, pickupAddress, deliveryAddress } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [isPickupAccess, setIsPickupAccess] = useState<boolean>(true);

  const mapLat =
    (isPickupAccess ? Number(pickupAddress?.latitude) : Number(deliveryAddress?.latitude)) ||
    DEFAULT_LATITUDE;

  const mapLong =
    (isPickupAccess ? Number(pickupAddress?.longitude) : Number(deliveryAddress?.longitude)) ||
    DEFAULT_LONGITUDE;

  return (
    <section>
      <header>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item sm={12} md={6} lg={6}>
            <div className="d-flex flex-column">
              <span className={classes.headerTitle}>
                {isPickupAccess ? translate("pickupAccess") : translate("deliveryAccess")}
              </span>
              <span className={classes.headerAddress}>
                {isPickupAccess ? pickupAddress?.longAddress : deliveryAddress?.longAddress}
              </span>
            </div>
          </Grid>
          <Grid
            item
            container
            sm={12}
            md={6}
            lg={6}
            justifyContent={window.innerWidth < 1000 ? "flex-start" : "flex-end"}
          >
            <Button customColor={Color.INFO} onClick={() => setIsPickupAccess(!isPickupAccess)}>
              {`Change to ${isPickupAccess ? "delivery" : "pickup"} access`}
            </Button>
          </Grid>
        </Grid>
      </header>
      <div>
        <BoxForm customClasses={classes.box}>
          <GoogleMap
            center={{
              lat: mapLat,
              lng: mapLong,
            }}
            zoom={17}
            mapContainerClassName={classes.map}
          >
            <Marker
              position={{
                lat: mapLat,
                lng: mapLong,
              }}
            />
          </GoogleMap>
        </BoxForm>
      </div>

      {isPickupAccess && pickupAccess ? (
        <AccessInfo access={pickupAccess} />
      ) : (
        <>{deliveryAccess && <AccessInfo access={deliveryAccess} />}</>
      )}
    </section>
  );
}
